import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { StoreState } from "../../reducers";
import {
  PDPPoints as PDPPointsComponent,
  PDPPointsComponentProps,
} from "../../components/PDPPoints";
import { getPDPPointsTotal } from "../../actions";
import {
  getIsLoadingPDPPointsTotal,
  getPDPPointsTotal as getPDPPointsTotalSelector,
} from "../../reducers/loyalty/methods";
import { getCampaignId } from "../../reducers/methods";

interface PDPPointsContainerProps extends PDPPointsComponentProps {
  getPDPPointsTotal: typeof getPDPPointsTotal;
  productSku: string;
  customerId: string;
  campaignId: string;
  isLoading: ReturnType<typeof getIsLoadingPDPPointsTotal>;
  pdpPointsTotal: ReturnType<typeof getPDPPointsTotalSelector>;
}

class PDPPoints extends React.Component<PDPPointsContainerProps> {
  componentDidMount() {
    const customer = get(this.props.data, "customer", {});
    const product = get(this.props.data, "product", {});

    if (
      !this.props.isLoading &&
      isEmpty(this.props.pdpPointsTotal) &&
      product &&
      product.sku
    ) {
      this.props.getPDPPointsTotal({
        campaignId: this.props.campaignId,
        product,
        amount: product.price,
        customerId: customer.id,
        email: customer.email,
      });
    }
  }

  render() {
    return <PDPPointsComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  pdpPointsTotal: getPDPPointsTotalSelector(state.loyalty),
  isLoading: getIsLoadingPDPPointsTotal(state.loyalty),
  campaignId: getCampaignId(state),
});

export default connect(mapStateToProp, { getPDPPointsTotal })(PDPPoints);
